/**
 * Entity Configuration
 * =====================
 * Defines the content type (post, recipe, product, etc.),
 * its data fields, labels, and parsing behavior.
 *
 * Per-profile: change labels, fields, and parser to match your content.
 */

// For this profile (anush.cuidarte): text posts, no structured items
const ENTITY_NAME = process.env.REACT_APP_ENTITY_NAME || 'respuesta';
const ENTITY_LABEL = process.env.REACT_APP_ENTITY_LABEL || 'Respuesta';
const ENTITY_LABEL_PLURAL = process.env.REACT_APP_ENTITY_LABEL_PLURAL || 'Respuestas';

const ITEM_PARSER = process.env.REACT_APP_ITEM_PARSER || 'generic';
const DATA_FIELD_ITEMS = process.env.REACT_APP_DATA_FIELD_ITEMS || 'items';
const DATA_FIELD_CLEANED_ITEMS = process.env.REACT_APP_DATA_FIELD_CLEANED_ITEMS || 'cleaned_items';

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

// Schema.org type for the main entity
const ENTITY_SCHEMA_TYPE = process.env.REACT_APP_ENTITY_SCHEMA_TYPE || 'Article';

export const ENTITY = {
  // Identity
  name: ENTITY_NAME,
  schemaType: ENTITY_SCHEMA_TYPE,
  label: ENTITY_LABEL,
  labelPlural: ENTITY_LABEL_PLURAL,
  labelLower: ENTITY_NAME.toLowerCase(),
  labelPluralLower: `${ENTITY_NAME.toLowerCase()}s`,

  // URL paths
  routes: {
    detail: `/:slug/`,
    detailPath: '',
    list: '/',
  },

  // Data field mappings
  dataFields: {
    items: DATA_FIELD_ITEMS,
    cleanedItems: DATA_FIELD_CLEANED_ITEMS,
    imageUrl: 'imageUrl',
    tags: 'tags',
    name: 'name',
    description: 'description',
    date: 'date',
    slug: 'slug',
    hidden: 'hidden',
    easy: 'easy',
    shortcode: 'shortcode',
    instagramUrl: 'instagramUrl',
    facebookUrl: 'facebookUrl',
    relatedPosts: 'related_posts',
  },

  // Item parser (generic for text-only content)
  itemParser: ITEM_PARSER,

  // UI Labels
  labels: {
    siteTitle: (name) => `${name}`,

    searchPlaceholder: `¿Qué ${ENTITY_NAME} buscás?`,

    emptyState: `No se encontraron ${ENTITY_NAME}s`,
    emptyStateDescription: 'Intentá ajustar tu búsqueda o filtros',

    resultsFormat: (count) => `Hay ${count} ${ENTITY_NAME}s para vos`,
    emptyResults: `No encontramos ${ENTITY_NAME}s con esos filtros`,

    easyFilter: 'Solo destacados',
    easyOverlay: 'Destacado',

    sectionDescription: 'Descripción',
    sectionItems: capitalize(DATA_FIELD_ITEMS),
    sectionTags: 'Tags',

    backToList: `Volver al listado de ${ENTITY_NAME}s`,
    backToListAria: `Volver al listado de ${ENTITY_NAME}s`,
    logoAria: 'Volver al inicio',

    relatedPosts: `${ENTITY_LABEL}s Relacionadas`,

    footerCta: null,
    authorIntro: null,

    notFound: `${ENTITY_LABEL} no encontrada`,
    notFoundMessage: (query) =>
      `No hay ningún ${ENTITY_NAME} con ese nombre. ¿Querés buscar "${query}"?`,

    searchButton: 'Buscar',
    clearFilters: 'Limpiar filtros',
    clearSearch: 'Limpiar búsqueda',
    scrollLeft: 'Scroll izquierda',
    scrollRight: 'Scroll derecha',

    viewOnInstagram: () => `Ver en Instagram`,
    shareOnFacebook: (label) => `Compartir ${label} en Facebook`,

    errorTitle: 'Algo salió mal',
    errorMessage: 'Hubo un error inesperado mientras preparábamos esta página.',
    errorLogged: 'No te preocupes, el error ya fue registrado.',
    errorRetry: 'Intentar de nuevo',
    errorGoHome: 'Volver al inicio',
  },

  // Tags
  featuredTags: ['Todos', 'Lactancia', 'Lesiones', 'Embarazo', 'Enfermeria', 'Recien nacido', 'Vacunacion'],

  // Default schema values
  defaults: {},

  // CSS selectors for speakable SEO
  cssSelectors: {
    detail: ['.post-name', '.post-description'],
    collection: ['.posts-grid', '.post-card', '.post-description'],
    breadcrumb: ['.breadcrumb'],
  },
};
